<template>
  <section class="container-fluid">
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <div class="row">
                <div class="col-12 col-xl-5">
                  <CIcon name="cil-grid" />Deuda de pensiones
                </div>
                <div class="col-12 col-xl--7">
                  <div class="row">
                    <div class="col-12 col-xl-3">
                      <div class="form-group">
                        <label class="control-label" for="courses_offered_year"
                          >Gestión:</label
                        >
                        <b-form-select
                          v-model="columnFilter.courses_offered_year"
                          :options="coursesOfferedYearsOptions"
                          id="courses_offered_year"
                          size="sm"
                          @change="filterTable"
                        >
                        </b-form-select>
                      </div>
                    </div>
                    <div class="col-12 col-xl-2">
                      <div class="form-group">
                        <label class="control-label" for="period"
                          >Periodo:</label
                        >

                        <b-form-select
                          v-model="columnFilter.courses_offered_period"
                          :options="periodOptions"
                          value-field="value"
                          text-field="name"
                          id="period"
                          size="sm"
                          @change="filterTable"
                        >
                        </b-form-select>
                      </div>
                    </div>
                    <div class="col-12 col-xl-6">
                      <div class="form-group">
                        <label for="course_offered_id" class="control-label"
                          >Curso</label
                        >
                        <!-- <b-form-select
                          v-model="columnFilter.course_offered_id"
                          :options="coursesOfferedOptions"
                          value-field="id"
                          text-field="name"
                          id="course_offered_id"
                          size="sm"
                          @change="filterTable"
                        >
                          <template #first>
                            <b-form-select-option :value="null"
                              >--Seleccione un curso--</b-form-select-option
                            >
                          </template>
                        </b-form-select> -->

                        <v-select
                          :options="coursesOfferedOptions"
                          label="name"
                          :reduce="(coursesOffered) => coursesOffered.id"
                          v-model="columnFilter.course_offered_id"
                          @input="filterTable"
                        ></v-select>
                      </div>
                    </div>
                    <div class="col-12 col-xl-1 float-right">
                      <button
                        @click="print()"
                        title="Reporte de venta"
                        class="btn btn-secondary btn-sm mt-3"
                        type="button"
                      >
                        <span><CIcon size="sm" name="cil-print" /></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </slot>
          </CCardHeader>
          <CCardBody>
            <CDataTable
              class="table-bordered c-table c-table-main"
              :hover="true"
              :striped="true"
              :bordered="true"
              :small="true"
              :items="items"
              :fields="fields"
              :sorter="{ external: true, resetable: true }"
              @update:sorter-value="filterTable"
              :columnFilter="{ external: true, lazy: true }"
              @update:column-filter-value="filterTable"
              :column-filter-value.sync="columnFilter"
              :loading="loading"
            >
              <template #no-items-view>
                <div class="no-items-view">
                  {{
                    loading
                      ? "Cargando datos..."
                      : "No existen cursos programados"
                  }}
                  <CIcon name="cil-ban" size="xl" v-if="!loading"></CIcon>
                </div>
              </template>
              <!-- filters -->
              <template #syllabus_tuition_id-filter>
                <b-form-select
                  v-model="columnFilter.syllabus_tuition_id"
                  :options="syllabusTuitionsOptions"
                  value-field="id"
                  text-field="name"
                  id="syllabus_tuition_id"
                  size="sm"
                  @change="filterTable"
                >
                  <template #first>
                    <b-form-select-option :value="null"
                      >--Seleccione un tipo de pensión--</b-form-select-option
                    >
                  </template>
                </b-form-select>
              </template>
              <template #enabled-filter>
                <v-select
                  :options="enabledOptions"
                  label="label"
                  :reduce="(enabledOption) => enabledOption.code"
                  v-model="columnFilter.enabled"
                  @input="filterTable"
                ></v-select>
              </template>
              <template #detail-filter>
                <b-button
                  @click="reload"
                  variant="secondary"
                  size="sm"
                  title="Recargar tabla"
                >
                  <CIcon size="sm" name="cil-reload" />
                </b-button>
                <b-button
                  @click="clean"
                  variant="secondary"
                  size="sm"
                  title="Limpiar filtros"
                >
                  <CIcon size="sm" name="cil-filter-x" />
                </b-button>
              </template>
              <!-- data -->
              <template #id="{ index }">
                <td>{{ (page - 1) * limit + (index + 1) }}</td>
              </template>
              <template #courses_offered_period="{ item }">
                <td>
                  {{ item.courses_offered_period }}/{{
                    item.courses_offered_year
                  }}
                </td>
              </template>
              <template #syllabus_id="{ item }">
                <td>
                  {{ item.syllabus_description }}
                </td>
              </template>
              <template #course_offered_id="{ item }">
                <td>
                  <span>
                    {{ item.course_name }}
                  </span>
                  <br />
                  <span>
                    Paralelo:
                    {{
                      item.courses_offered_parallel == "NONE"
                        ? "Ninguno"
                        : item.courses_offered_parallel
                    }}
                  </span>
                </td>
              </template>
              <template #syllabus_tuition_id="{ item }">
                <td>
                  {{ item.syllabus_tuition_name }}
                </td>
              </template>
              <template #tuition_price="{ item }">
                <td class="text-right">
                  {{ item.tuition_price | currency }}
                </td>
              </template>
              <template #detail>
                <td></td>
              </template>
            </CDataTable>
          </CCardBody>
          <div>
            <CPagination
              :activePage.sync="page"
              :pages="pages"
              size="sm"
              align="center"
              @update:activePage="updateTable"
            />
            <TableRecords
              :total="total"
              :loading="loading"
              :from="from"
              :to="to"
              :page="page"
            />
          </div>
        </CCard>
      </CCol>
    </CRow>
  </section>
</template>
<script>
import {
  BAlert,
  BModal,
  BButton,
  BButtonGroup,
  BFormSelect,
  BFormSelectOption,
} from "bootstrap-vue";

import TableRecords from "@/components/shared/TableRecords";
import { Utils } from "@/plugins/utils";
import Constants from "@/plugins/constants";
// services
import Registrations from "@/plugins/services/registrations";
import Syllabus from "@/plugins/services/syllabus";
import SyllabusTuitions from "@/plugins/services/syllabus-tuitions";
import CoursesOffered from "@/plugins/services/courses-offered";
// components
import RegistrationAddModal from "@/entities/registrations/RegistrationAddModal";
import SaleRegistrationAddModal from "@/entities/sales/SaleRegistrationAddModal";
import RegistrationDeleteModal from "@/entities/registrations/RegistrationDeleteModal";
import RegistrationEditModal from "@/entities/registrations/RegistrationEditModal";

export default {
  name: "RegistrationListModal",
  components: {
    BAlert,
    BModal,
    BButton,
    BButtonGroup,
    BFormSelect,
    BFormSelectOption,
    TableRecords,
    RegistrationAddModal,
    SaleRegistrationAddModal,
    RegistrationDeleteModal,
    RegistrationEditModal,
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "#",
          sorter: false,
          filter: false,
          _style: "width: 8px;",
        },
        {
          key: "courses_offered_period",
          label: "Periodo",
          filter: false,
          _style: "width: 10%;",
        },
        {
          key: "student_fullname",
          label: "Estudiante",
        },
        {
          key: "course_offered_id",
          label: "Curso",
          _style: "width: 15%;",
          filter: false,
        },
        {
          key: "syllabus_tuition_id",
          label: "Tipo de pensión",
          _style: "width: 15%;",
        },
        {
          key: "tuition_price",
          label: "Precio pensión",
          filter: false,
          _style: "width: 8%;",
        },
        {
          key: "detail",
          label: "Acciones",
          sorter: false,
          _style: "width: 110px;",
        },
      ],
      items: [],
      columnFilter: {
        asc: false,
        enabled: true,
        column: "created_at",
        courses_offered_year: null,
        courses_offered_period: null,
      },
      enabledOptions: Constants.enabledOptions,
      periodOptions: Constants.periodOptions,
      coursesOfferedYearsOptions: [],
      coursesOfferedOptions: [],
      syllabusTuitionsOptions: [],
      page: 0,
      pages: 0,
      limit: 20,
      from: 0,
      to: 0,
      total: 0,
      loading: true,
    };
  },
  watch: {
    "columnFilter.courses_offered_year"(courses_offered_year) {
      this.getSyllabusTuitions();
      this.getCoursesOffered();
    },
    "columnFilter.courses_offered_period"(courses_offered_period) {
      this.getCoursesOffered();
    },
  },
  mounted() {
    this.columnFilter.courses_offered_year = Utils.getYear(this.userAuth.now);
    this.getAll(this.columnFilter);
    this.getCoursesOfferedYears();
  },
  computed: {
    userAuth() {
      return this.$store.state.userAuth;
    },
  },
  methods: {
    getAll(q = null, page = null) {
      this.loading = true;
      Registrations.allDebts(q, this.limit, page).then((res) => {
        this.loading = false;
        this.items = res.data.data;
        this.page = res.data.current_page;
        this.pages = res.data.last_page;
        this.total = res.data.total;
        this.from = res.data.from;
        this.to = res.data.to;
      });
    },
    updateTable(page) {
      this.getAll(this.columnFilter, page);
    },
    filterTable(columnFilter) {
      this.columnFilter = { ...this.columnFilter, ...columnFilter };
      this.getAll(this.columnFilter);
    },
    clean() {
      this.columnFilter = {
        asc: false,
        enabled: true,
        courses_offered_year: Utils.getYear(this.userAuth.now),
        column: "created_at",
        courses_offered_period: null,
      };
      this.getAll(this.columnFilter);
    },
    reload() {
      this.getAll(this.columnFilter);
    },
    getCoursesOfferedYears() {
      this.coursesOfferedYearsOptions = Utils.getYears(this.userAuth.now);
    },
    getSyllabusTuitions() {
      SyllabusTuitions.selectAllTwo({
        year: this.columnFilter.courses_offered_year,
      })
        .then((res) => {
          this.syllabusTuitionsOptions = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCoursesOffered() {
      CoursesOffered.selectAll({
        courses_offered_year: this.columnFilter.courses_offered_year,
        period: this.columnFilter.courses_offered_period,
      })
        .then((res) => {
          this.coursesOfferedOptions = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    print() {
      let cFilter = this.columnFilter;
      let querystring = Utils.encodeQueryData(cFilter);
      let teacherSchedule = `${process.env.MIX_APP_API_ENDPOINT}/registrations/debts-pdf?${querystring}`;
      Utils.printPdf(teacherSchedule);
    },
  },
};
</script>
